import moment from 'moment';
import DTO from './DTO';

class RegistryOfSuspensionReasonsDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'name',
        type: String,
        validators: {},
        labelKey: 'registry.template.name',
      },
      {
        name: 'procedures',
        type: String,
        validators: {},
        labelKey: 'registry.template.procedures',
      },
      {
        name: 'block_180_days',
        type: String,
        validators: {},
        labelKey: 'registry.template.block_180_days',
      },
      {
        name: 'legal_entity_types',
        type: String,
        validators: {},
        labelKey: 'legal_entity_type',
      },
      {
        name: 'law_number',
        type: String,
        validators: {},
        labelKey: 'registry.template.law_number',
      },
      {
        name: 'message',
        type: String,
        validators: {},
        labelKey: 'registry.template.message',
      },
      {
        name: 'additional_message',
        type: String,
        validators: {},
        labelKey: 'registry.template.additional_message',
      },
      {
        name: 'creator_id',
        type: String,
        validators: {},
        labelKey: 'registry.template.creator_id',
      },
      {
        name: 'reasons_type',
        type: String,
        validators: {},
        labelKey: 'registry.template.reasons_type',
      },
      {
        name: 'reasons_types',
        type: String,
        validators: {},
        labelKey: 'registry.template.reasons_type',
      },
      {
        name: 'argument_type',
        type: String,
        validators: {},
        labelKey: 'registry.argument_type',
      },
      {
        name: 'argument_value',
        type: String,
        validators: {},
        labelKey: 'registry.argument_value',
      },
      {
        name: 'ekdl_message',
        type: String,
        validators: {},
        labelKey: 'registry.ekdl_message',
      },
    ];

    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default RegistryOfSuspensionReasonsDTO;
